(() => {
  const selector = 'h1,h2,h3,h4,h5,h6,button,[role="button"],input[type="submit"],input[type="button"],a.button,a[class*="button--"],.lya-button,.menu-list__link,.menu-drawer__menu-item,.lya-collection-links a,nav a,summary';
  const small = new Set('a an the and but or nor for so yet as at by down for from in into of off on onto out over past per through to under up upon via with within without about above across after against along amid among around before behind below beneath beside between beyond despite during except inside like near outside regarding round since throughout toward towards underneath until unlike versus'.split(' '));
  const acronyms = new Set('CRP USA US CE CEU CEUs PTSD ADHD LPC LCSW LCDC NCC NBC HWC LOSS FAQ FAQs SEO LGBTQ LGBTQIA LGBTQIA2S'.split(' '));
  const titleCase = (text) => {
    const words = [...text.matchAll(/[\p{L}\p{N}]+(?:[’'][\p{L}\p{N}]+)*/gu)];
    let cursor = 0;
    let output = '';
    words.forEach((match, index) => {
      const word = match[0];
      const lower = word.toLocaleLowerCase('en');
      const preceding = text.slice(cursor, match.index);
      const boundary = index === 0 || index === words.length - 1 || /[:.!?]\s*$/.test(preceding);
      let converted = word;
      if (small.has(lower) && !boundary) converted = lower;
      else if (!acronyms.has(word)) {
        const base = word === word.toLocaleUpperCase('en') ? lower : word;
        converted = base.charAt(0).toLocaleUpperCase('en') + base.slice(1);
      }
      output += preceding + converted;
      cursor = match.index + word.length;
    });
    return output + text.slice(cursor);
  };
  const apply = (element) => {
    if (element.closest('[contenteditable="true"],script,style,textarea,svg,[data-lya-case="preserve"]')) return;
    if (element.hasAttribute('aria-label') && element.matches('button,[role="button"],input[type="submit"],input[type="button"]')) {
      const label = element.getAttribute('aria-label');
      const convertedLabel = titleCase(label);
      if (label !== convertedLabel) element.setAttribute('aria-label', convertedLabel);
    }
    if (element instanceof HTMLInputElement) {
      const value = titleCase(element.value);
      if (element.value !== value) element.value = value;
      return;
    }
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => node.parentElement.closest('script,style,svg,.visually-hidden,.sr-only,[aria-hidden="true"],[data-lya-case="preserve"]') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    const original = nodes.map((node) => node.data).join('');
    const converted = titleCase(original);
    if (original === converted) return;
    let offset = 0;
    nodes.forEach((node) => {
      const length = node.data.length;
      const replacement = converted.slice(offset, offset + length);
      if (node.data !== replacement) node.data = replacement;
      offset += length;
    });
  };
  let queued = false;
  const update = () => {
    queued = false;
    if (!document.documentElement.lang.startsWith('en')) return;
    document.querySelectorAll(selector).forEach(apply);
  };
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  });
  update();
  observer.observe(document.body, { childList: true, characterData: true, subtree: true });
})();


/* Keep all collection entry links at the All Products heading. */
(() => {
 const fix = () => document.querySelectorAll('a[href]').forEach(a => {
   const label = a.textContent.trim().replace(/\s+/g, ' ').toLowerCase();
   if (label !== 'shop all products' && label !== 'all products') return;
   const url = new URL(a.getAttribute('href'), location.href);
   if (url.origin === location.origin && /\/collections\/all-products-1\/?$/.test(url.pathname)) {
     if (url.hash !== '#all-products') { url.hash = 'all-products'; a.setAttribute('href', url.pathname + url.search + url.hash); }
   }
 });
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
 new MutationObserver(fix).observe(document.documentElement, {childList:true, subtree:true});
})();
